"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelCreatorOptions = void 0;
var ModelCreatorOptions = (function () {
    function ModelCreatorOptions() {
        this.fillCharStyles = true;
        this.fillParStyles = true;
        this.fillTableStyles = true;
        this.addParagraph = true;
        this.addSection = true;
        this.fillAbstractNumberingListTemplates = true;
        this.initOfficeTheme = true;
    }
    return ModelCreatorOptions;
}());
exports.ModelCreatorOptions = ModelCreatorOptions;
